import { HashRouter as Router } from "react-router-dom";
import BasicLayout from "@components/BasicLayout";
import { useRecoilValue } from "recoil";
import { appState } from "@store/recoil";
import { homeStateSelector } from "./store/redux/modules/home";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { maxDisplayWidth } from "./config";
import { _css } from "./utils/dom";
import lodash from "lodash";
import { NavigationGuard, RouteProtector } from "@/RouteProtector";
import { Location } from "react-router-dom";
import NProgress from "@/utils/progress";
import { isTestLink } from "./utils";
import { RootState } from "./types/store";

const App: React.FC = () => {
  // @ts-ignore
  window.globalState = {};
  const dispatch = useDispatch();
  // @ts-ignore
  window.globalState = {
    // @ts-ignore
    ...window.globalState,
    dispatch,
  };

  const getAppState = useRecoilValue(appState.appAtom);
  const homeState = useSelector((state: RootState) => homeStateSelector(state));
  const getAppStyles = (): React.CSSProperties => {
    const bgImageUrl = getAppState.appBgImageUrl;
    const isWeatherBgSet = homeState?.info?.weatherBg || LocalStorage.getItem("info")?.weatherBg;
    return {
      ...(isWeatherBgSet && {
        backgroundImage: `url(${bgImageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }),
      ...(isWeatherBgSet ? {} : { backgroundColor: "#087BD8" }),
      zIndex: "-1",
      position: "fixed",
      left: "50%",
      top: 0,
      transform: "translateX(-50%)",
      maxWidth: `${maxDisplayWidth}px`,
      width: "100vw",
      height: "100vh",
    };
  };

  window.onbeforeunload = function () {
    LocalStorage.removeItem("info");
    SessionStorage.clear();
  };
  const adContainerRef = useRef<any>(null);

  const beforeEach: NavigationGuard = useCallback((to, from, next) => {
    console.log(`[路由守卫] 准备从 ${from?.pathname} 跳转到 ${to.pathname}`);
    NProgress.start();
    next();
  }, []);

  const afterEach = useCallback((to: Location, from: Location | null) => {
    console.log(`[路由守卫] 已完成从 ${from?.pathname} 跳转到 ${to.pathname}`);
    NProgress.done();
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  const getAdComponent = (): JSX.Element | null => {
    if (
      !isTestLink(domains) &&
      !lodash.flatten(Object.values(lodash.omit(domainMap, ["miwg"]))).includes(window.location.hostname)
    ) {
      return null;
    }

    const adType = (() => {
      if ([...domainMap["wi"], ...domainMap["wg"]].includes(window.location.hostname)) return 2;
      if ([...domainMap["v-ls"], ...domainMap["mxwg"], ...domainMap["mils"]].includes(window.location.hostname))
        return 1;
      return 1;
    })();

    return <GoogleAd {...useGoogleAd("320x100", adType)} />;
  };

  useEffect(() => {
    const { isArLan } = useLanguage();
    if (isArLan) {
      document.body.setAttribute("dir", "rtl");
    }
  }, []);

  return (
    <>
      <div style={getAppStyles()}></div>
      <div className="w-full overflow-x-hidden">
        <AppContext.Provider value={{}}>
          <Router
            future={{
              v7_relativeSplatPath: true,
              v7_startTransition: true,
            }}
          >
            {/* <AliveScope> */}
            <RouteProtector beforeEach={beforeEach} afterEach={afterEach}>
              <BasicLayout />
            </RouteProtector>
            {/* </AliveScope> */}
          </Router>
        </AppContext.Provider>
      </div>
      <div ref={adContainerRef} className="fixed bottom-0 left-0 w-full flex flex-col justify-end items-center">
        {getAdComponent()}
      </div>
    </>
  );
};
export default App;
